import { action } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore, SelectColumn } from './agt.analytics.store';

export interface IAkumaPlanerMultiGp26Model {
	agtId: number;
	kwsAbove50Count: number;
}

export class AkumaPlanerMultiGp26Model implements IAkumaPlanerMultiGp26Model {
	agtId: number;
	kwsAbove50Count: number;

	constructor(data: any) {
		this.agtId = data.vtnr_id || 0;
		this.kwsAbove50Count = data.kws_above_50_count || 0;
	}
}

export class AgtAkumaPlanerMultiGp26Store extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'agentur_akumaplaner_multigp26',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE },
				{ column: 'kws_above_50_count', aggregateFunction: AggregateFunction.NONE },
			],
		});
		this.queryName = '?akumaPlanerMultiGp26';
	}

	@action
	async findAll(): Promise<AkumaPlanerMultiGp26Model[]> {
		const selectColumns: SelectColumn[] = [
			{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE },
			{ column: 'kws_above_50_count', aggregateFunction: AggregateFunction.NONE },
		];
		const results = await this.query(selectColumns);
		return results.map((data) => new AkumaPlanerMultiGp26Model(data));
	}
}
